module.exports = __webpack_public_path__ + "img/icon_home_hezuo_one@3x.e734e420.png";